import {
  createErrorResultExt,
  createSuccessResult,
  IStationInfo,
  SimpleResult,
  TInfoItem,
} from "@ryde/shared";

export const useRideValidators = () => {
  const validateStationInfo = (
    station: IStationInfo | undefined,
  ): SimpleResult<TInfoItem[]> => {
    if (!station) {
      return createSuccessResult([]);
    }

    const warnings = new Set<TInfoItem>();

    if (
      !Number(station.locationInfo?.latitude) ||
      !Number(station.locationInfo?.longitude)
    ) {
      warnings.add({ translationKey: "errors.missingCoordinates" });
    }

    if (!station.areaId) {
      warnings.add({ translationKey: "errors.missingArea" });
    }

    return createErrorResultExt({ data: [...warnings] });
  };

  return { validateStationInfo };
};
